var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crip-notice",class:( _obj = {
        'crip-notice-closable': _vm.closable,
        'crip-notice-with-desc': _vm.withDesc,
      }, _obj[("crip-notice-" + _vm.type)] = true, _obj[_vm.className] = !!_vm.className, _obj ),style:(_vm.styles),on:{"mousemove":_vm.clearCloseTimer,"mouseover":_vm.clearCloseTimer,"mouseout":_vm.setCloseTimer}},[_c('notice-content',{attrs:{"type":_vm.type,"title":_vm.title,"description":_vm.description,"icons":_vm.icons}},[(_vm.closable)?_c('a',{staticClass:"crip-notice-close",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.close($event)}}},[_c('i',{class:_vm.icons.close})]):_vm._e()])],1)
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a456426","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notice.vue
// module id = 23
// module chunks = 0